import type { SsrRequestContext } from './ssr-request-context'

interface RouteSdkOptionsConfig {
	auth?: boolean
	signal?: AbortSignal
}

export interface RouteSdkOptions {
	baseUrl?: string
	headers?: HeadersInit
	signal?: AbortSignal
}

export function getRouteSdkOptions(
	{ serverContext }: { serverContext?: SsrRequestContext },
	config: RouteSdkOptionsConfig = {}
): RouteSdkOptions {
	return {
		...(serverContext
			? {
					baseUrl: serverContext.sdkBaseUrl,
					headers: {
						...serverContext.sdkBaseHeaders,
						...(config.auth
							? serverContext.sdkForwardedAuthHeaders
							: {})
					}
				}
			: {}),
		...(config.signal ? { signal: config.signal } : {})
	}
}
